import { convertDateTime } from "Helpers/date";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ViewIcon from "../../../../Assets/images/error-outline.svg";
import ReactTable from "../../../../Components/Table/Table";
import { AppContext } from "../../../../Context/AppContext";
import {
  MODULES,
  ORDER_STATUS_FILTER,
  ORDER_TYPE,
} from "../../../../Helpers/Constants";
import { formatUsPhone } from "../../../../Hooks/commanUtility";
// Context
import { getAccessByModuleName } from "../../../../Routes/Routes";
// Components
import Header from "../../../../Components/Header/Header";
import { useUser } from "../../../../Context/UserContext/useUser";
import LoadingScreen from "../../../../Components/Loading/LoadingScreen";
import { getSystemOrderLookup } from "api/order";
import GlobalDateFilters from "Components/GlobalDateFilters/GlobalDateFilters";
const SystemOrdersList = () => {
  const navigate = useNavigate();
  const { showToastMessage, modules } = useContext(AppContext);
  const [userData, setUserData] = useState("");
  const { userState, reLogin } = useUser();
  const getUserData = async () => {
    if (userState?.userProfile?.id) {
      setUserData(userState?.userProfile?.user_type);
    } else {
      const user = await reLogin();
      setUserData(user?.user_type);
    }
  };
  useEffect(() => {
    getUserData();
  }, []);

  const statusList = ORDER_STATUS_FILTER;
  const orderTypeList = ORDER_TYPE;

  // Default Values
  let defaultFromDate = moment()
    .subtract(6, "days")
    .startOf("day")
    .format("ddd MMM DD, YYYY");
  let deafultToDate = moment().endOf("day").format("ddd MMM DD, YYYY");
  let defaultFilterValue = {
    pageIndex: 0,
    pageSize: 10,
    sortBy: [
      {
        id: "order_number",
        desc: "desc",
      },
    ],
    filters: [{ id: "order_status", value: "" }],
    globalFilter: "",
  };
  let defaultType = "order_date";
  // Table Constants
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  // Date Range Filter Start
  const [type, setType] = useState(defaultType);
  const [fromDate, setFromDate] = useState(defaultFromDate);
  const [toDate, setToDate] = useState(deafultToDate);
  // Date Range Filter End

  const [defaultFilter, setDefaultFilter] = useState(defaultFilterValue);
  const [firstRender, setFirstRender] = useState(true);
  const [isCustomSearch, setIsCustomSearch] = useState(false);
  const [columnStateSaveData, setColumnStateSaveData] = useState({});

  // Set Async Data
  const setAsyncData = (data) => {
    let asyncDataValues = JSON.stringify(data);
    localStorage.setItem("asyncDataValuesSystemOrders", asyncDataValues);
  };
  // Get And Set Data Into State
  useEffect(() => {
    const filterData = JSON.parse(
      localStorage.getItem("asyncDataValuesSystemOrders")
    );
    if (filterData) {
      const {
        currentPage,
        itemsPerPage,
        globalSearch,
        filters,
        sortBy,
        date_type,
        start_date,
        end_date,
      } = filterData;
      setDefaultFilter({
        filters: filters,
        pageIndex: currentPage,
        globalFilter: globalSearch,
        pageSize: itemsPerPage,
        sortBy: sortBy,
      });
      setType(date_type);
      setFromDate(moment(start_date).format("ddd MMM DD, YYYY"));
      setToDate(moment(end_date).format("ddd MMM DD, YYYY"));
    }
    setFirstRender(false);

    const columnStateData = JSON.parse(
      localStorage.getItem("columnDataStateSaveSystemOrders")
    );
    setColumnStateSaveData(columnStateData);
  }, []);

  // // Handle On Start Date Change Validation
  // const handleFromDate = async (fromDate) => {
  //   setFromDate(fromDate);
  // };
  // // Handle On End Date Change Validation
  // const handleToDate = async (toDate) => {
  //   setToDate(toDate);
  // };
  // Date Validation
  const dateValidation = (fromDate, toDate) => {
    let todayDate = moment(new Date()).format("x");
    let startDate = moment(fromDate).format("x");
    let endDate = moment(toDate).format("x");
    if (startDate > endDate) {
      showToastMessage(
        undefined,
        "End date should be greater than start date",
        "error",
        false
      );
      return false;
    }
    let daysDiff = moment(fromDate).diff(toDate, "days");
    daysDiff = daysDiff < 0 ? daysDiff * -1 : daysDiff;
    if (
      userData &&
      userData !== "super_admin" &&
      userData !== "admin" &&
      startDate < todayDate &&
      daysDiff > 60
    ) {
      showToastMessage(
        undefined,
        "You can select maximum 60 days back from current date for start date",
        "error",
        false
      );
      return false;
    }
    return true;
  };

  // Fetch Records
  const fetchData = async ({
    pageIndex,
    pageSize,
    sortBy,
    globalFilter,
    filters,
    fromDateDefault,
    toDateDefault,
    latestData,
  }) => {
    if (
      !dateValidation(
        fromDateDefault ? fromDateDefault : fromDate,
        toDateDefault ? toDateDefault : toDate
      )
    ) {
      return false;
    }
    pageIndex = latestData ? 0 : pageIndex;
    setLoading(true);
    let postData = {
      currentPage: pageIndex,
      itemsPerPage: pageSize,
      globalSearch: globalFilter,
      filters,
      sortBy,
      date_type: type,
      start_date: fromDateDefault
        ? moment(fromDateDefault).format("YYYY-MM-DD")
        : moment(fromDate).format("YYYY-MM-DD"),
      end_date: toDateDefault
        ? moment(toDateDefault).format("YYYY-MM-DD")
        : moment(toDate).format("YYYY-MM-DD"),
    };
    let orderAccess = getAccessByModuleName(
      modules,
      MODULES.SYSTEM_ORDER_LOOKUP
    );
    if (orderAccess && orderAccess.permissions.read_access) {
      const response = await getSystemOrderLookup(postData);
      if (response && response.status === 200) {
        setData(response.data.data.rows);
        setPageCount(Math.ceil(response.data.data.count / pageSize));
        setTotalCount(response.data.data.count);
      } else {
        showToastMessage(undefined, response.data.message, "error", false);
      }
    }
    setLoading(false);
    setAsyncData(postData);
    setDefaultFilter({ pageSize, pageIndex, filters, globalFilter, sortBy });
    setIsCustomSearch(false);
  };

  //Search clear
  const handleClearSearch = async (event) => {
    event.preventDefault();
    // Condition According To Order Type For Start Date And End Date
    setType(defaultType);
    setFromDate(defaultFromDate);
    setToDate(deafultToDate);
    setIsCustomSearch(true);
    fetchData({
      ...defaultFilter,
      latestData: true,
      fromDateDefault: defaultFromDate,
      toDateDefault: deafultToDate,
    });
  };

  const selectedColumn = async (column) => {
    let columnData = JSON.stringify(column);
    localStorage.setItem("columnDataStateSaveSystemOrders", columnData);
  };

  useEffect(getModuleAccess, [modules]);
  function getModuleAccess() {
    let access = getAccessByModuleName(modules, MODULES.SYSTEM_ORDER_LOOKUP);
    if (access && !access.permissions.read_access) {
      showToastMessage(
        undefined,
        "You are not authorized to access.",
        "error",
        false
      );
      navigate(`/users`);
    }
  }
  let accountAccess = getAccessByModuleName(
    modules,
    MODULES.SYSTEM_ACCOUNT_LOOKUP
  );
  let viewOrderAccess = getAccessByModuleName(
    modules,
    MODULES.SYSTEM_ORDER_LOOKUP
  );
  const columns = React.useMemo(
    () => [
      {
        Header: "Order No",
        accessor: "order_number",
        isVisible: columnStateSaveData?.order_number ?? true,
        placeholder: "Order No",
      },
      {
        Header: "Customer Name",
        accessor: "customer_name",
        isVisible: columnStateSaveData?.customer_name ?? true,
        placeholder: "Customer Name",
        Cell: ({ value, row, column }) => {
          return row.original.order_transaction?.customer_id === 0 ||
            row.original.order_transaction?.customer_id === undefined ? (
            <span>{`${row.original.order_transaction.customer_name}`}</span>
          ) : accountAccess && accountAccess.permissions.write_access ? (
            <Link
              to={`/reports/system-customer/${row.original.order_transaction.customer_id}`}
            >
              <span className={`cursor-pointer`}>
                {`${row.original.order_transaction.customer_name}`}
              </span>
            </Link>
          ) : (
            <span>{`${row.original.order_transaction.customer_name}`}</span>
          );
        },
      },
      {
        Header: "Recipient Name",
        accessor: "recipient_name",
        isVisible: columnStateSaveData?.recipient_name ?? true,
        placeholder: "Recipient Name",
        Cell: ({ value, row, column }) => {
          return `${row.original.order_recipients[0].recipient_name}`;
        },
      },
      {
        Header: "Customer Phone",
        accessor: "customer_phone",
        isVisible: columnStateSaveData?.customer_phone ?? true,
        placeholder: "Customer Phone",
        Cell: ({ value, row, column }) => {
          return `${
            row.original.order_transaction.customer_phone
              ? row.original.order_transaction.customer_phone_country_code +
                " " +
                formatUsPhone(row.original.order_transaction.customer_phone)
              : ""
          }`;
        },
      },
      {
        Header: "Recipient Phone",
        accessor: "recipient_phone",
        isVisible: columnStateSaveData?.recipient_phone ?? true,
        placeholder: "Recipient Phone",
        Cell: ({ value, row, column }) => {
          return `${
            row.original.order_recipients[0].recipient_phone
              ? row.original.order_recipients[0].phone_country_code +
                " " +
                formatUsPhone(row.original.order_recipients[0].recipient_phone)
              : ""
          }`;
        },
      },
      {
        Header: "Delivery Date",
        accessor: "delivery_date_time",
        isVisible: columnStateSaveData?.delivery_date_time ?? true,
        placeholder: "Delivery Date",
        Cell: ({ value, row, column }) => {
          return `${
            row.original.delivery_date_time &&
            row.original.delivery_date_time !== null
              ? row.original.delivery_time_type === "Anytime"
                ? convertDateTime(
                    row.original.delivery_date_time,
                    "iso",
                    "ccc LLL dd, yyyy"
                  ) +
                  " " +
                  row.original.delivery_time_type
                : convertDateTime(
                    row.original.delivery_date_time,
                    "iso",
                    "ccc LLL dd, yyyy, hh:mm a"
                  )
              : ""
          }`;
        },
        disableFilters: true,
      },
      {
        Header: "Order Date",
        accessor: "createdAt",
        isVisible: columnStateSaveData?.createdAt ?? true,
        placeholder: "Order Date",
        Cell: ({ value, row, column }) => {
          return `${
            row.original.createdAt && row.original.createdAt !== null
              ? convertDateTime(
                  row.original.createdAt,
                  "iso",
                  "ccc LLL dd, yyyy, hh:mm a"
                )
              : ""
          }`;
        },
        disableFilters: true,
      },
      {
        Header: "Price",
        accessor: "total",
        placeholder: "Price",
        isVisible: columnStateSaveData?.total ?? false,
        Cell: ({ value, row, column }) => {
          return `$${row.original.total.toFixed(2)}`;
        },
      },
      {
        Header: "Customer Email",
        accessor: "customer_email",
        placeholder: "Customer Email",
        isVisible: columnStateSaveData?.customer_email ?? false,
        Cell: ({ value, row, column }) => {
          return `${row.original.order_transaction.customer_email}`;
        },
      },
      {
        Header: "Customer Address",
        accessor: "customer_address",
        placeholder: "Customer Address",
        isVisible: columnStateSaveData?.customer_address ?? false,
        Cell: ({ value, row, column }) => {
          return `${row.original.order_transaction.customer_address}`;
        },
      },
      {
        Header: "Recipient Address",
        accessor: "recipient_address",
        placeholder: "Recipient Address",
        isVisible: columnStateSaveData?.recipient_address ?? false,
        Cell: ({ value, row, column }) => {
          return `${row.original.order_recipients[0].recipient_address}`;
        },
      },
      {
        Header: "Order Type",
        accessor: "is_burq_order",
        isVisible: columnStateSaveData?.is_burq_order ?? true,
        placeholder: "Order Type",
        isSelectFilter: true,
        selectFilterOption: orderTypeList,
        colWidth: 160,
        Cell: ({ value, row, column }) => {
          return (
            <div>
              {row.original.is_burq_order === 1
                ? "On-Demand"
                : row.original.is_burq_order === 0 &&
                  row.original.order_onfleet?.onfleet_task_id != null
                ? "Onfleet"
                : "-"}
            </div>
          );
        },
      },
      {
        Header: "Status",
        accessor: "order_status",
        isVisible: columnStateSaveData?.order_status ?? true,
        placeholder: "Status",
        isSelectFilter: true,
        selectFilterOption: statusList,
        colWidth: 160,
        Cell: ({ value, row, column }) => {
          let orderStatusData = statusList.filter(
            (status) => status.id === row.original.order_status
          );
          if (
            row.original.order_status === "cancel" &&
            row.original.is_burq_order === 1
          ) {
            if (row.original.is_cancel_fail_by_burq === 1) {
              return "Driver Cancelled";
            } else if (row.original.is_order_cancel_on_burq_also === 0) {
              return (
                <span>
                  Cancel <span style={{ color: "red" }}> * </span>{" "}
                </span>
              );
            } else {
              return `${
                orderStatusData.length ? orderStatusData[0]["title"] : "-"
              }`;
            }
          } else {
            return `${
              orderStatusData.length ? orderStatusData[0]["title"] : "-"
            }`;
          }
        },
      },
      {
        Header: "Type",
        accessor: "source",
        placeholder: "Type",
        isVisible: columnStateSaveData?.source ?? false,
      },
      {
        Header: "External Order Number",
        accessor: "external_order_number",
        placeholder: "External Order Number",
        isVisible: columnStateSaveData?.external_order_number ?? false,
      },
      {
        Header: "Shop Code",
        accessor: "shopcode",
        placeholder: "Shop Code",
        isVisible: columnStateSaveData?.shopcode ?? false,
      },
      {
        Header: "Actions",
        accessor: "id",
        isVisible: columnStateSaveData?.id ?? true,
        disableSortBy: true,
        Cell: ({ value, row, column }) => {
          return (
            <div>
              {viewOrderAccess && viewOrderAccess.permissions.read_access ? (
                <Link to={`/reports/system-orders/view/${row.original.id}`}>
                  <img
                    className={`cursor-pointer mr-2 view-icon`}
                    src={ViewIcon}
                    alt="View Order"
                  />
                </Link>
              ) : (
                <span style={{ width: 34, height: 34, display: "block" }} />
              )}
            </div>
          );
        },
      },
    ],
    [columnStateSaveData]
  );

  if (firstRender) return <LoadingScreen />;
  return (
    <React.Fragment>
      <Header title={`System Order Lookup (${totalCount})`} />
      <div id="MainContent" className="main-content">
        <div className="row">
          <div className="col-12 p-0">
            <GlobalDateFilters
              isClearSearchBtn
              isSearchIcon
              isDateFilter
              isFilterByOption
              fetchData={() => {
                fetchData({
                  ...defaultFilter,
                  latestData: true,
                });
                setIsCustomSearch(true);
              }}
              setType={setType}
              type={type}
              fromDate={fromDate}
              toDate={toDate}
              setToDate={setToDate}
              setFromDate={setFromDate}
              handleClearSearch={handleClearSearch}
              dateFormate={"YYYY-MM-DD"}
              key={"system-order-lookup"}
            />
          </div>
        </div>
        <ReactTable
          columns={columns}
          data={data}
          fetchData={fetchData}
          loading={loading}
          pageCount={pageCount}
          noDataText={"There is no data to display"}
          defaultFilter={defaultFilter}
          displayGlobalSearch={false}
          displayColumnVisibility={true}
          isCustomSearch={isCustomSearch}
          selectedColumn={selectedColumn}
        />
      </div>
    </React.Fragment>
  );
};

export default SystemOrdersList;
